import React from 'react';
import classNames from 'clsx';

import { useStyles } from './LabelWithBrackets.styles';
import { LabelWithBracketsProps } from './LabelWithBrackets.interfaces';

export default function LabelWithBrackets(props: LabelWithBracketsProps) {
  const { label, textInBrackets } = props;
  const classes = useStyles();

  return (
    <div
      className={classNames(classes.container, {
        [classes.greyedText]: textInBrackets === 0,
      })}
    >
      {label}
      <span className={classes.brackets}>&nbsp;{`(${textInBrackets})`}</span>
    </div>
  );
}
